import React from 'react';
import GiftsDashboardPage from './GiftsDashboardPage';
import GiftsDashboardPageMobile from './GiftsDashboardPageMobile'; 

const isMobile = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= 768;
};

const GiftsDashboardPageWrapper: React.FC = () => {
  const [mobile, setMobile] = React.useState(isMobile());

  React.useEffect(() => {
    const handleResize = () => {
      setMobile(isMobile());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return mobile ? <GiftsDashboardPageMobile /> : <GiftsDashboardPage />;
};

export default GiftsDashboardPageWrapper; 